import { toast, Toaster as SonnerToaster } from "sonner";

export { toast };

export function Toaster() {
  return (
    <SonnerToaster
      position="top-center"
      toastOptions={
        {
          // className: "px-4 py-3",
          // style: {
          //   borderRadius: "0.75rem",
          //   boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          //   border: `1px solid #000000`,
          // },
        }
      }
    />
  );
}
